import { LogOut, RefreshCw } from 'lucide-react';
import { useState } from 'react';
import errorIllustration from '../../assets/images/exclamation-mark.png';
import { Button } from '../../design-system/button/button';
import { Inline } from '../../design-system/inline/inline';
import { Stack } from '../../design-system/stack/stack';

const LOGOUT_URL = '/auth/logout';

export const ErrorPage = () => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Stack space={4} align="center" className="mt-48">
      <Stack space={2} align="center">
        <div className="h-40 w-40">
          <img
            src={errorIllustration}
            alt=""
            loading="eager"
            fetchPriority="high"
            className="h-full w-full object-cover"
          />
        </div>

        <h2 className="text-center text-2xl font-medium">Something went wrong</h2>

        <p className="text-center text-base font-medium text-seapoint-gray-text">
          We've been notified of the issue. Please try refreshing the page.
        </p>
      </Stack>

      <Inline space={3}>
        <Button
          iconLeft={<RefreshCw size={16} />}
          isLoading={isLoading}
          onClick={() => {
            setIsLoading(true);

            window.location.reload();
          }}
        >
          Refresh Page
        </Button>

        <Button variant="outline" iconLeft={<LogOut size={16} />} onClick={() => (window.location.href = LOGOUT_URL)}>
          Logout
        </Button>
      </Inline>
    </Stack>
  );
};
